export default __webpack_public_path__ + "static/media/sticker-wh.3b6dac31.png";